import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import IconCheck from 'editor/src/component/Icon/IconCheck';

import styles from './index.module.scss';

function SavedBadge() {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.savedBadge, 'cy-library-saved-badge')}>
      <IconCheck className={styles.icon} />
      {t('editor-library-saved-badge')}
    </div>
  );
}

export default React.memo(SavedBadge);
